import { render, staticRenderFns } from "./AxResultPage.vue?vue&type=template&id=21e1b9cc&scoped=true&"
import script from "./AxResultPage.vue?vue&type=script&lang=js&"
export * from "./AxResultPage.vue?vue&type=script&lang=js&"
import style0 from "./AxResultPage.vue?vue&type=style&index=0&id=21e1b9cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1b9cc",
  null
  
)

export default component.exports